import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as AddBackorderDemandEvent from '@ori-events/add-backorder-demand';
import * as AddToBasketEvent from '@ori-events/add-to-basket';
import * as AddToBasketFailedEvent from '@ori-events/add-to-basket-failed';
import * as BasketUpdatedEvent from '@ori-events/basket-updated';
import * as LoyaltyDialogResultEvent from '@ori-events/loyalty-dialog-result';
import { useEffect, useRef, useState } from 'react';
import { QUICK_BUY_BUTTON_STATE_DEFAULT, QUICK_BUY_BUTTON_STATE_ERROR, QUICK_BUY_BUTTON_STATE_LOADING, QUICK_BUY_BUTTON_STATE_SUCCESS, QUICK_BUY_BUTTON_STATE_WAITING } from "../../common";
export var useOnClickEvent = function useOnClickEvent(_ref) {
  var addToBasketMethod = _ref.addToBasketMethod,
    currentPrice = _ref.currentPrice,
    currentProductCode = _ref.currentProductCode,
    lineNumber = _ref.lineNumber,
    name = _ref.name,
    placement = _ref.placement,
    originalItemCode = _ref.originalItemCode,
    position = _ref.position;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  useEffect(function () {
    if (lineNumber == null) {
      setEvent(new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          formattedPrice: currentPrice,
          itemCode: currentProductCode,
          localName: name,
          method: addToBasketMethod,
          originalItemCode: originalItemCode,
          placement: placement,
          position: position,
          quantity: 1
        }
      }));
    } else {
      setEvent(new CustomEvent(AddBackorderDemandEvent.Name, {
        detail: {
          formattedPrice: currentPrice,
          itemCode: currentProductCode,
          lineNumber: lineNumber,
          localName: name,
          placement: placement,
          position: position,
          quantity: 1
        }
      }));
    }
  }, [addToBasketMethod, currentPrice, currentProductCode, lineNumber, name, originalItemCode, placement, position]);
  return event;
};
export var useQuickBuyEvents = function useQuickBuyEvents(_ref2) {
  var currentProductCode = _ref2.currentProductCode,
    setState = _ref2.setState;
  var timeoutRef = useRef();
  useEffect(function () {
    var onBasketUpdated = function onBasketUpdated(_ref3) {
      var _detail$lastAddedItem;
      var detail = _ref3.detail;
      if (((_detail$lastAddedItem = detail.lastAddedItem) === null || _detail$lastAddedItem === void 0 ? void 0 : _detail$lastAddedItem.itemCode) === currentProductCode) {
        setState(QUICK_BUY_BUTTON_STATE_SUCCESS);
        timeoutRef.current = setTimeout(function () {
          return setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
        }, 3000);
      } else {
        setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    };
    var onAddToBaskedFailed = function onAddToBaskedFailed() {
      setState(QUICK_BUY_BUTTON_STATE_ERROR);
      timeoutRef.current = setTimeout(function () {
        return setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
      }, 300);
    };
    var onOtherAddToBasket = function onOtherAddToBasket(_ref4) {
      var detail = _ref4.detail;
      if (detail.itemCode === currentProductCode) {
        setState(QUICK_BUY_BUTTON_STATE_LOADING);
      } else {
        setState(QUICK_BUY_BUTTON_STATE_WAITING);
      }
    };
    var onLoyaltyDialogClose = function onLoyaltyDialogClose(_ref5) {
      var detail = _ref5.detail;
      if (detail.result === LoyaltyDialogResultEvent.LoyaltyDialogResults.CLOSE) {
        setState(QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    };
    window.addEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
    window.addEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
    window.addEventListener(LoyaltyDialogResultEvent.Name, onLoyaltyDialogClose);
    return function () {
      clearTimeout(timeoutRef.current);
      window.removeEventListener(AddToBasketEvent.Name, onOtherAddToBasket);
      window.removeEventListener(AddToBasketFailedEvent.Name, onAddToBaskedFailed);
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
      window.removeEventListener(LoyaltyDialogResultEvent.Name, onLoyaltyDialogClose);
    };
  }, [currentProductCode, setState]);
};
//# sourceMappingURL=hooks.js.map